import { IosToggle } from '../../../general_components/content_management/reusableItems/iosToggle';
import { CustomLoadingIcon } from '../../../supplementary_components/loading_icon';
import styles from './fuelCardStatusToggle.module.scss';

export function FuelCardStatusToggle({ isActive, loading, disabled, onToggle }) {
    const toggleDisabled = disabled || loading;

    return (
        <div className={styles.fuelCardToggle}>
            <div className={styles.fuelCardToggleInner}>
                <IosToggle state={isActive} onChangeAction={onToggle} disabled={toggleDisabled} />
                {loading ? (
                    <div
                        className={`${styles.fuelCardToggleLoader} ${
                            isActive ? styles.fuelCardToggleLoaderRight : styles.fuelCardToggleLoaderLeft
                        }`}
                    >
                        <CustomLoadingIcon
                            height="0.65rem"
                            strokeColor="var(--light-gray)"
                            customStrokeWidth="0.15rem"
                        />
                    </div>
                ) : null}
            </div>
        </div>
    );
}
